(function(){
    let overlay, closeButton, showOverlayTimer, hideOverlayTimer, showPhotoTimer, hidePhotoTimer;

    const prevent = event => {
        event.preventDefault();
        event.stopPropagation();
    }

    $(document).on('contentAdded', () => {
        $('a.youtube').each((index, element) => {

            element = $(element);
            let anchor = element.find('.thumbnail');
            let src = element.find('img').attr('src');
            let container, player, embed;

            const keydown = event => {
                switch (event.key) {
                    case $.key.escape:
                        deactivate();
                        break;
                    default:
                        return;
                }
                event.preventDefault();
                event.stopPropagation();
            }

            const deactivate = () => {
                // Hide overlay

                overlay.addClass('closed');
                if (showOverlayTimer) clearTimeout(showOverlayTimer);
                if (hideOverlayTimer) clearTimeout(hideOverlayTimer);
                hideOverlayTimer = setTimeout(function(){
                    overlay.remove();
                    closeButton.remove();
                }, 300);

                // Hide content

                $('#content').removeAttr('aria-hidden');
                container.removeAttr('aria-modal').removeClass('visible').addClass('closed');

                var photoRect = anchor[0].getBoundingClientRect();
                container.css({
                    left: photoRect.left + photoRect.width / 2,
                    top: photoRect.top + photoRect.height / 2,
                    width: photoRect.width,
                    height: photoRect.height
                });

                if (showPhotoTimer) clearTimeout(showPhotoTimer);
                if (hidePhotoTimer) clearTimeout(hidePhotoTimer);
                hidePhotoTimer = setTimeout(function() {
                    element.removeClass('viewing');
                    container.remove().css({
                        left: null,
                        top: null,
                        width: null,
                        height: null
                    });
                }, 300);

                $(document).off('keydown', keydown);
            }

            element.on('click', event => {
                event.preventDefault();
                event.stopPropagation();

                if (!container) {
                    container = $('<div class="video-viewer"/>')
                        .on('click', deactivate)
                        .on('wheel mousewheel DOMMouseScroll', prevent);
                    let wrapper = $('<div class="video-wrapper"/>').on('click', prevent).appendTo(container);
                    player = $('<div class="video-player"/>').appendTo(wrapper);
                    $('<div class="preview"/>').css('background-image', 'url(' + src + ')').appendTo(player);
                    embed = $('<iframe src="" width="560" height="315" frameborder="0"/>')
                        .attr('src', element.data('embed') + '?autoplay=1&modestbranding=1&showinfo=0&rel=0&iv_load_policy=3&color=white')
                        .appendTo(player);
                }

                // Show overlay

                if (showOverlayTimer) clearTimeout(showOverlayTimer);
                if (hideOverlayTimer) clearTimeout(hideOverlayTimer);

                if (!overlay) {
                    overlay = $('<div id="viewer-overlay"/>');
                    overlay.on('click', deactivate);
                    overlay.on('wheel mousewheel DOMMouseScroll', prevent);
                    closeButton = $('<button type="button" id="close-viewer"/>');
                    closeButton.on('click', deactivate);
                }

                showOverlayTimer = setTimeout(function() {
                    overlay.removeClass('closed offscreen').appendTo(document.body);
                    closeButton.appendTo(document.body);
                }, 100);

                // Show container

                $('#content').attr('aria-hidden', 'true');
                container.attr('aria-modal', 'true');

                var photoRect = anchor[0].getBoundingClientRect();
                container.removeClass('closed offscreen').appendTo(document.body);
                embed.removeClass('visible');
                container.css({
                    left: photoRect.x + photoRect.width / 2,
                    top: photoRect.y + photoRect.height / 2,
                    width: photoRect.width,
                    height: photoRect.height
                });

                if (showPhotoTimer) clearTimeout(showPhotoTimer);
                if (hidePhotoTimer) clearTimeout(hidePhotoTimer);
                showPhotoTimer = setTimeout(function() {
                    container.addClass('visible');
                    element.addClass('viewing');
                    showPhotoTimer = setTimeout(function() {
                        embed.addClass('visible').focus();
                    }, 700);
                }, 100);

                $(document).on('keydown', keydown);
            })
        });
    });

})()
